// import React, { useState, useRef, useEffect } from 'react'
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { Link } from 'react-router-dom';
// import EmojiPicker from "emoji-picker-react";
// import useClickOutside from './coutomclickhooks';
// import axios from "axios";
// import { FaArrowLeftLong } from "react-icons/fa6";
// import { FaWhatsapp } from "react-icons/fa";
// import { FaInstagram } from "react-icons/fa";
// import { FaWifi } from "react-icons/fa";
// import { MdOutlineSignalCellularConnectedNoInternet4Bar } from "react-icons/md";
// import { MdBatteryFull } from "react-icons/md";
// import { FaShop } from "react-icons/fa6";
// import { RxDotsVertical } from "react-icons/rx";
// import { CiFaceSmile } from "react-icons/ci";
// import { FaPaperclip } from "react-icons/fa";
// import { FaCamera } from "react-icons/fa";
// import { FaMicrophone } from "react-icons/fa";
// import { IoIosArrowDown } from "react-icons/io";
// import { IoIosVideocam } from "react-icons/io";
// import { IoDocumentTextOutline } from "react-icons/io5";
// import { ImLocation } from "react-icons/im";
// import { IoMdAdd } from "react-icons/io";
// import { FaPhotoVideo } from "react-icons/fa";
// import { BiSolidShare } from "react-icons/bi";
// import { LuSquareArrowOutUpRight } from "react-icons/lu";
// import { IoCall } from "react-icons/io5";
// import { FaClipboardCheck } from "react-icons/fa6";
// import { FaCopy } from "react-icons/fa";
// import { RxCross1 } from "react-icons/rx";
// import { BsInfoCircle } from "react-icons/bs";




// import whatsappnotch from '../images/Wp-notch-image.png'
// import Whatsappicon from '../images/Whatsappicon.png'
// import whatsappBgimage from '../images/whatsapp-mobile-image.png'
// import whatsappBodyBgimage from '../images/whatsappBackground.jpg'
// import Gobackmodal from './gobackmodal';

// function decodeToken(token) {
//     if (!token) return {};
//     try {
//         const base64Url = token.split('.')[1];
//         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//         const jsonPayload = decodeURIComponent(
//             atob(base64)
//                 .split('')
//                 .map(function (c) {
//                     return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
//                 })
//                 .join('')
//         );
//         return JSON.parse(jsonPayload);
//     } catch (e) {
//         return {};
//     }
// }

// function getUserIdFromTokenOrLocatorgarsotrga() {
//     if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
//         const rawToken = window.locatorgarsotrga("token");
//         if (rawToken) {
//             const decoded = decodeToken(rawToken);
//             const userId = decoded.id || decoded.userId || decoded._id;
//             return { userId, token: rawToken };
//         }
//     }
//     const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
//     if (rawToken) {
//         const decoded = decodeToken(rawToken);
//         const userId = decoded.id || decoded.userId || decoded._id;
//         return { userId, token: rawToken };
//     }
//     return { userId: null, token: null };
// }

// function Edittemplate({ setActive }) {

//     let param = useParams();

//     const navigate = useNavigate();
//     const location = useLocation();
//     const params = new URLSearchParams(location.search);

//     const { activetab, choosetemplate } = location.state || {};
//     const Datatext = params.get("text") || "";

//     const dropdownRef = useRef(null);
//     const emojiRef = useRef(null)
//     const addbutton = useRef(null)
//     useClickOutside([dropdownRef, emojiRef, addbutton], () => {
//         setmediadropdown(false);
//         setShowPicker(false);
//         setshowaddbutton(false)
//     });


//     const [templateName, settemplateName] = useState('')
//     const [showmedia, setshowmedia] = useState('none')
//     const [mediadropdown, setmediadropdown] = useState(false)
//     const [mediavalue, setmediavalue] = useState('none')
//     const [mediaType, setMediaType] = useState("none");
//     const [headervalue, setheadervalue] = useState('Hello')
//     const [bodyvalue, setbodyvalue] = useState(Datatext)
//     const [footervalue, setfootervalue] = useState('')
//     const [headerVars, setHeaderVars] = useState({});
//     const [bodyVars, setBodyVars] = useState({});
//     const [showPicker, setShowPicker] = useState(false);
//     const [showaddbutton, setshowaddbutton] = useState(false);
//     const [openUpward, setOpenUpward] = useState(false);
//     const [customvalue, setcustomvalue] = useState('Quick Reply')
//     const [customvalueType, setcustomvalueType] = useState('custom')
//     const [custom, setcustom] = useState(false)
//     const [visitwebsite, setvisitwebsite] = useState(false)
//     const [visitwebsiteText, setvisitwebsitetext] = useState('Visit website')
//     const [visitwebsiteURL, setvisitwebsiteURL] = useState('')
//     const [visitwebsiteURLtype, setvisitwebsiteURLtype] = useState('Static')
//     const [callphone, setcallphone] = useState(false);
//     const [callphonebtntext, setcallphonebtntext] = useState('Call phone');
//     const [phonenumber, setphonenumber] = useState('')
//     const [countrycode, setcountrycode] = useState('+91')
//     const [countrycodetype, setcountrycodetype] = useState('IN+91')
//     const [copyoffercode, setcopyoffercode] = useState(false)
//     const [offercode, setoffercode] = useState('')
//     const [copybtntext, setcopybtntext] = useState('Copy offer code')
//     const [isActive, setisActive] = useState(false);
//     const [Validity, setValidity] = useState('')
//     const [open, setopen] = useState(false)
//     const [edittemplate, setedittemplate] = useState({})
//     const[selectedWabaId, setSelectedWabaId] = useState('');

//     function addtemplate() {
//         console.log(
//             templateName,
//             headervalue,
//             bodyvalue,
//             footervalue
//         )
//     }


//     const [whatsappData, setWhatsappData] = useState([]);
//     const [messageLimits, setMessageLimits] = useState([]); // <-- Store per WABA channel message limits
//     const { userId, token } = getUserIdFromTokenOrLocatorgarsotrga();

//     useEffect(() => {
//         const fetchWhatsappData = async () => {
//             try {
//                 const api_url = process.env.REACT_APP_API_URL || "https://wa-api.globebot.io";
//                 const headers = token ? { Authorization: `${token}` } : {};
//                 const response = await axios.get(`${api_url}/auth/my-whatsapp`, { headers });
//                 setWhatsappData(Array.isArray(response.data) ? response.data : []);
//             } catch (err) {
//                 setWhatsappData([]);
//             }
//         };
//         fetchWhatsappData();
//     }, [token]);
//     //  Extract unique variables
//     const extractVariables = (text) => {
//         const matches = text.match(/{{(\d+)}}/g) || [];
//         const numbers = matches.map((m) => m.replace(/[{}]/g, ""));
//         return [...new Set(numbers)];
//     };

//     //  Preview replace
//     const previewText = (text, variables) => {
//         return text.replace(/{{(\d+)}}/g, (_, key) => {
//             return variables[key] || `{{${key}}}`;
//         });
//     };

//     //  Add Variable Button Logic
//     const addVariable = (value, setValue) => {
//         const matches = value.match(/{{(\d+)}}/g) || [];
//         const numbers = matches.map((m) => m.replace(/[{}]/g, ""));

//         let next = 1;
//         while (numbers.includes(String(next))) {
//             next++;
//         }

//         setValue(value.trimEnd() + ` {{${next}}}`);
//     };

//     const normalizeVariables = (text) => {
//         let count = 1;
//         let map = {};

//         return text.replace(/{{(\d+)}}/g, (_, num) => {
//             if (!map[num]) {
//                 map[num] = count;
//                 count++;
//             }
//             return `{{${map[num]}}}`;
//         });
//     };
//     const handleEmojiClick = (emojiData) => {
//         setbodyvalue((prev) => prev + emojiData.emoji);
//     };


//     const getAcceptType = () => {
//         switch (mediaType) {
//             case "image":
//                 return "image/*";
//             case "video":
//                 return "video/*";
//             case "document":
//                 return ".pdf,.doc,.docx";
//             default:
//                 return "*";
//         }
//     };

//     const handleToggle = () => {
//         const rect = addbutton.current.getBoundingClientRect();

//         const spaceBelow = window.innerHeight - rect.bottom;
//         const dropdownHeight = 200;

//         if (spaceBelow < dropdownHeight) {
//             setOpenUpward(true);
//         } else {
//             setOpenUpward(false);
//         }

//         setshowaddbutton(!showaddbutton);
//     };

//     const templates = [
//         {
//             id: 1,
//             name: "Welcome Template",
//             header: "Welcome!",
//             body: "Hello {{name}}, welcome to our service.",
//             footer: "Thank you for joining us",
//             buttonText: "Get Started",
//             link: 'https://www.example.com'
//         },
//         {
//             id: 2,
//             name: "Order Confirmation",
//             header: "Order Confirmed",
//             body: "Hi {{name}}, your order #{{order_id}} is confirmed.",
//             footer: "We appreciate your purchase",
//             buttonText: "View Order",
//         },
//         {
//             id: 3,
//             name: "Delivery Update",
//             header: "Out for Delivery",
//             body: "Your order is on the way and will reach soon.",
//             footer: "Track your delivery",
//             buttonText: "Track Order",
//             link: 'https://www.example.com'
//         },
//         {
//             id: 4,
//             name: "Payment Reminder",
//             header: "Payment Pending",
//             body: "Hi {{name}}, your payment is still pending.",
//             footer: "Please complete it soon",
//             buttonText: "Pay Now",
//         },
//         {
//             id: 5,
//             name: "Appointment Reminder",
//             header: "Reminder",
//             body: "You have an appointment scheduled on {{date}}.",
//             footer: "Don't forget to attend",
//             buttonText: "View Details",
//         },
//         {
//             id: 6,
//             name: "Discount Offer",
//             header: "Special Offer",
//             body: "Get {{discount}}% off on your next purchase.",
//             footer: "Limited time only",
//             buttonText: "Shop Now",
//             link: 'https://www.example.com'
//         },
//         {
//             id: 7,
//             name: "Feedback Request",
//             header: "We Value Your Feedback",
//             body: "Please share your experience with us.",
//             footer: "Your feedback matters",
//             buttonText: "Give Feedback",
//         },
//         {
//             id: 8,
//             name: "Account Alert",
//             header: "Security Alert",
//             body: "A new login detected on your account.",
//             footer: "If this wasn't you, contact support",
//             buttonText: "Secure Account",
//         },
//         {
//             id: 9,
//             name: "Subscription Renewal",
//             header: "Renewal Reminder",
//             body: "Your subscription will expire soon.",
//             footer: "Renew to continue services",
//             buttonText: "Renew Now",
//         },
//         {
//             id: 10,
//             name: "Event Invitation",
//             header: "You're Invited!",
//             body: "Join us for our upcoming event.",
//             footer: "Save your spot now",
//             buttonText: "Register",
//         },
//     ];

//     const findobject = templates.find((item) => (
//         item.id === Number(param.id)
//     ))



//     return (
//         <>
//             <div className='w-[100%] px-4'>
//                 <div className='flex gap-4 border-t-[1px] border-[#cfcdcd] pt-2'>

//                     {/* Setup Template */}
//                     <div
//                         onClick={() => navigate('/WAMessage/WATemplate/SetupTemplate')}
//                         className={`flex items-center gap-2 text-[12px] font-bold p-[5px] rounded-lg border-[1px] cursor-pointer
//     ${location.pathname.includes('/WAMessage/WATemplate/SetupTemplate')
//                                 ? 'text-[#31b07b] border-[#31b07b]'
//                                 : 'text-[#9e9d9d] border-[#9e9d9d]'}`}
//                     >
//                         <div

//                             className={`w-[15px] h-[15px] border-[1px] rounded-full flex justify-center items-center
//       ${location.pathname.includes('/WAMessage/WATemplate/SetupTemplate')
//                                     ? 'border-[#31b07b] bg-[#31b07b]'
//                                     : 'border-[#9e9d9d]'}`}
//                         >
//                             {location.pathname.includes('/WAMessage/WATemplate/SetupTemplate') && (
//                                 <div className='w-[7px] h-[7px] bg-[#fff] rounded-full'></div>
//                             )}
//                         </div>
//                         Set up template
//                     </div>

//                     {/* Edit Template */}
//                     <div
//                         onClick={() => navigate('/WAMessage/WATemplate/AddEditTemplate')}
//                         className={`flex items-center gap-2 text-[12px] font-bold p-[5px] rounded-lg border-[1px] cursor-pointer
//     ${location.pathname.includes('/WAMessage/WATemplate/AddEditTemplate')
//                                 ? 'text-[#31b07b] border-[#31b07b]'
//                                 : 'text-[#9e9d9d] border-[#9e9d9d]'}`}
//                     >
//                         <div
//                             className={`w-[15px] h-[15px] border-[1px] rounded-full flex justify-center items-center
//       ${location.pathname.includes('/WAMessage/WATemplate/AddEditTemplate')
//                                     ? 'border-[#31b07b] bg-[#31b07b]'
//                                     : 'border-[#9e9d9d]'}`}
//                         >
//                             {location.pathname.includes('/WAMessage/WATemplate/AddEditTemplate') && (
//                                 <div className='w-[7px] h-[7px] bg-[#fff] rounded-full'></div>
//                             )}
//                         </div>
//                         Edit template
//                     </div>

//                 </div>

//                 <div className='w-[100%] flex  flex-col md:flex-row mt-4 md:p-0 p-2  '>
//                     <div className='w-[100%] md:w-[70%] flex flex-col px-0 py-2 mb-[20px] md:mb-[0px] '>
//                         <div className='w-[100%] flex-wrap flex justify-between items-center shadow-[0_2px_6px_rgba(0,0,0,0.1)] p-4 rounded-md  '>
//                             <div className='flex gap-4 items-center w-[100%] sm:w-[50%]  '>
//                                 <div className='w-[35px] h-[35px] bg-[#1D9E91] flex items-center justify-center rounded-lg'>
//                                     🔔
//                                 </div>
//                                 <div className=''>
//                                     <p className='text-[14px] text-[#474646] font-semibold '>your_template_name • English</p>
//                                     <p className='text-[12px] text-[#474646]'> {(activetab || 'Marketing')} • {(choosetemplate || 'Default')}</p>
//                                 </div>
//                             </div>
//                             <div className='flex items-center justify-end gap-4 w-[100%] sm:w-[50%] mt-2 sm:mt-0'>
//                                 <label className='text-[#1D9E91] text-[14px] font-bold' htmlFor="AllowCategoryChange"> Allow Category Change</label>
//                                 <input className=' accent-[#1D9E91] w-[16px] h-[16px] rounded-[20px]' type="checkbox" name="" id="AllowCategoryChange" />
//                             </div>
//                         </div>
//                         <div className='w-[100%] flex justify-between items-center shadow-[0_2px_6px_rgba(0,0,0,0.1)] p-4 rounded-md mt-4 '>
//                             <div className='w-[100%] flex flex-wrap gap-4'>

//                                 <div className='w-full sm:w-[48%] md:w-[31%]  flex flex-col gap-1'>
//                                     <label className='text-[#000] w-[100%] flex justify-between text-[12px] font-semibold dark:text-[#fff]'>Template Name : <span className='text-[10px] font-semibold text-[#888686]'>{templateName.length}/512</span></label>
//                                     <input className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]' type="text"
//                                         value={templateName}
//                                         onChange={(e) => settemplateName(e.target.value)}
//                                         placeholder='Enter a template name'
//                                         maxLength={512}
//                                     />{templateName.length === 0 ?
//                                         <span className='text-[12px] text-red-600 font-semibold'>You need to enter a name for your template.</span> : ''
//                                     }

//                                 </div>
//                                 <div className='w-full sm:w-[48%] md:w-[31%]  flex flex-col gap-1'>
//                                     <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Select language</label>
//                                     <select className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 dark:bg-[#121519] dark:text-[#fff]'>
//                                         <option value="sq">Albanian</option>
//                                         <option value="ar">Arabic</option>
//                                         <option value="ar_EG">Arabic (Egypt)</option>
//                                         <option value="ar_AE">Arabic (UAE)</option>
//                                         <option value="ar_LB">Arabic (Lebanon)</option>
//                                         <option value="ar_MA">Arabic (Morocco)</option>
//                                         <option value="ar_QA">Arabic (Qatar)</option>
//                                         <option value="ar_SA">Arabic (Saudi Arabia)</option>
//                                         <option value="az">Azerbaijani</option>
//                                         <option value="bn">Bengali</option>
//                                         <option value="bg">Bulgarian</option>
//                                         <option value="ca">Catalan</option>
//                                         <option value="zh_CN">Chinese (China)</option>
//                                         <option value="zh_HK">Chinese (Hong Kong)</option>
//                                         <option value="zh_TW">Chinese (Taiwan)</option>
//                                         <option value="hr">Croatian</option>
//                                         <option value="cs">Czech</option>
//                                         <option value="da">Danish</option>
//                                         <option value="nl">Dutch</option>
//                                         <option selected="selected" value="en">English</option>
//                                         <option value="en_AU">English (Australia)</option>
//                                         <option value="en_CA">English (Canada)</option>
//                                         <option value="en_GH">English (Ghana)</option>
//                                         <option value="en_IN">English (India)</option>
//                                         <option value="en_IE">English (Ireland)</option>
//                                         <option value="en_JM">English (Jamaica)</option>
//                                         <option value="en_MY">English (Malaysia)</option>
//                                         <option value="en_NZ">English (New Zealand)</option>
//                                         <option value="en_QA">English (Qatar)</option>
//                                         <option value="en_SG">English (Singapore)</option>
//                                         <option value="en_GB">English (UK)</option>
//                                         <option value="en_US">English (US)</option>
//                                         <option value="en_UG">English (Uganda)</option>
//                                         <option value="en_ZA">English (South Africa)</option>
//                                         <option value="et">Estonian</option>
//                                         <option value="fil">Filipino</option>
//                                         <option value="fi">Finnish</option>
//                                         <option value="fr">French</option>
//                                         <option value="ka">Georgian</option>
//                                         <option value="de">German</option>
//                                         <option value="el">Greek</option>
//                                         <option value="gu">Gujarati</option>
//                                         <option value="ha">Hausa</option>
//                                         <option value="he">Hebrew</option>
//                                         <option value="hi">Hindi</option>
//                                         <option value="hu">Hungarian</option>
//                                         <option value="id">Indonesian</option>
//                                         <option value="ga">Irish</option>
//                                         <option value="it">Italian</option>
//                                         <option value="ja">Japanese</option>
//                                         <option value="kn">Kannada</option>
//                                         <option value="kk">Kazakh</option>
//                                         <option value="rw_RW">Kinyarwanda</option>
//                                         <option value="ko">Korean</option>
//                                         <option value="ky_KG">Kyrgyz (Kyrgyzstan)</option>
//                                         <option value="lo">Lao</option>
//                                         <option value="lv">Latvian</option>
//                                         <option value="lt">Lithuanian</option>
//                                         <option value="mk">Macedonian</option>
//                                         <option value="ms">Malay</option>
//                                         <option value="ml">Malayalam</option>
//                                         <option value="mr">Marathi</option>
//                                         <option value="nb">Norwegian</option>
//                                         <option value="fa">Persian</option>
//                                         <option value="pl">Polish</option>
//                                         <option value="pt_BR">Portuguese (Brazil)</option>
//                                         <option value="pt_PT">Portuguese (Portugal)</option>
//                                         <option value="pa">Punjabi</option>
//                                         <option value="ro">Romanian</option>
//                                         <option value="ru">Russian</option>
//                                         <option value="sr">Serbian</option>
//                                         <option value="sk">Slovak</option>
//                                         <option value="sl">Slovenian</option>
//                                         <option value="es">Spanish</option>
//                                         <option value="es_AR">Spanish (Argentina)</option>
//                                         <option value="es_ES">Spanish (Spain)</option>
//                                         <option value="es_MX">Spanish (Mexico)</option>
//                                         <option value="sw">Swahili</option>
//                                         <option value="sv">Swedish</option>
//                                         <option value="ta">Tamil</option>
//                                         <option value="te">Telugu</option>
//                                         <option value="th">Thai</option>
//                                         <option value="tr">Turkish</option>
//                                         <option value="uk">Ukrainian</option>
//                                         <option value="ur">Urdu</option>
//                                         <option value="uz">Uzbek</option>
//                                         <option value="vi">Vietnamese</option>
//                                         <option value="zu">Zulu</option>
//                                     </select>
//                                 </div>

//                                 <div className='w-full sm:w-[48%] md:w-[31%]  flex flex-col gap-1'>
//                                     <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>WABA Account</label>
//                                     <select
//                                         className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 dark:bg-[#121519] dark:text-[#fff]'
//                                         value={selectedWabaId}
//                                         onChange={(e) => setSelectedWabaId(e.target.value)}
//                                     >
//                                         <option value="">Select WABA Account</option>
//                                         {whatsappData.map((data) => (
//                                             <option key={data.waba_id} value={data.waba_id}>
//                                                 {data.waba_id}
//                                             </option>
//                                         ))}
//                                     </select>
                               
//                                 </div>

//                             </div>
//                         </div>

//                         <div className='w-[100%]   shadow-[0_2px_6px_rgba(0,0,0,0.1)] p-4 rounded-md mt-4'>
//                             <div className='flex flex-col md:flex-row w-full gap-4'>

//                                 {/* LEFT SECTION */}
//                                 <div className='w-full md:w-[40%]'>

//                                     <div className='bg-[#edf1f5] rounded-[5px] py-1 px-2 w-fit flex justify-center'>
//                                         <span className='text-[12px] font-semibold'>
//                                             <span className='text-[#535252]'>Media sample •</span> Optional
//                                         </span>
//                                     </div>
//                                     <div
//                                         ref={dropdownRef}
//                                         onClick={() => setmediadropdown(!mediadropdown)}
//                                         className='w-full md:w-[300px] border border-[#d4cfcf] rounded-md mt-4 flex justify-between items-center text-[12px] p-2 text-[#454546] relative'
//                                     >
//                                         <div className='w-full flex justify-between items-center'>
//                                             <span className='font-semibold'>{mediavalue}</span>
//                                             <IoIosArrowDown />
//                                         </div>
//                                         {mediadropdown && (
//                                             <div className='w-full md:w-[150px] absolute top-full left-0 mt-1 z-50 bg-white shadow-md rounded'>
//                                                 {/* OPTIONS */}
//                                                 <div
//                                                     onClick={() => {
//                                                         setmediadropdown(false);
//                                                         setmediavalue('none');
//                                                         setMediaType('none');
//                                                     }}
//                                                     className='py-2 flex pl-4 bg-[#f6f9fc]'
//                                                 >
//                                                     <input type="radio" checked={mediavalue === 'none'} readOnly />
//                                                     <label className='ml-2 font-semibold'>None</label>
//                                                 </div>

//                                                 <div
//                                                     onClick={() => {
//                                                         setmediadropdown(false);
//                                                         setmediavalue('Image');
//                                                         setMediaType('Image');
//                                                     }}
//                                                     className='py-2 flex pl-4'
//                                                 >
//                                                     <input type="radio" checked={mediavalue === 'Image'} readOnly />
//                                                     <label className='ml-2 flex items-center gap-1 font-semibold'>
//                                                         <FaCamera /> Image
//                                                     </label>
//                                                 </div>

//                                                 <div
//                                                     onClick={() => {
//                                                         setmediadropdown(false);
//                                                         setmediavalue('Video');
//                                                         setMediaType('Video');
//                                                     }}
//                                                     className='py-2 flex pl-4 bg-[#f6f9fc]'
//                                                 >
//                                                     <input type="radio" checked={mediavalue === 'Video'} readOnly />
//                                                     <label className='ml-2 flex items-center gap-1 font-semibold'>
//                                                         <IoIosVideocam /> Video
//                                                     </label>
//                                                 </div>

//                                                 <div
//                                                     onClick={() => {
//                                                         setmediadropdown(false);
//                                                         setmediavalue('document');
//                                                         setMediaType('document');
//                                                     }}
//                                                     className='py-2 flex pl-4'
//                                                 >
//                                                     <input type="radio" checked={mediavalue === 'document'} readOnly />
//                                                     <label className='ml-2 flex items-center gap-1 font-semibold'>
//                                                         <IoDocumentTextOutline /> Document
//                                                     </label>
//                                                 </div>

//                                                 <div
//                                                     onClick={() => {
//                                                         setmediadropdown(false);
//                                                         setmediavalue('Location');
//                                                         setMediaType('Location');
//                                                     }}
//                                                     className='py-2 flex pl-4 bg-[#f6f9fc]'
//                                                 >
//                                                     <input type="radio" checked={mediavalue === 'Location'} readOnly />
//                                                     <label className='ml-2 flex items-center gap-1 font-semibold'>
//                                                         <ImLocation /> Location
//                                                     </label>
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>

//                                 {/* RIGHT SECTION */}
//                                 <div className={`${mediaType === 'none' ? 'hidden' : 'flex'} w-full md:w-[50%] flex-col`}>

//                                     <div className='bg-[#edf1f5] rounded-[5px] py-1 px-2 w-fit flex justify-center'>
//                                         <span className='text-[12px] font-semibold text-[#535252]'>
//                                             Upload Media
//                                         </span>
//                                     </div>

//                                     <div className="border border-[#edf1f5] rounded text-center bg-[#f6f9fc] p-3 mt-2 w-full md:w-[70%]">

//                                         <label className="cursor-pointer text-blue-500 text-[12px] flex items-center justify-center gap-1">
//                                             <FaPhotoVideo />
//                                             Choose <span className="font-bold">{mediaType}</span> to upload

//                                             <input
//                                                 type="file"
//                                                 name="mediaFile"
//                                                 className="hidden"
//                                                 accept={getAcceptType()}
//                                             />
//                                         </label>

//                                         <div className="text-gray-500 text-[12px] mt-1">
//                                             {mediaType === "Image" && (
//                                                 <span className="text-red-500 font-medium">
//                                                     Max Image Size 5MB
//                                                 </span>
//                                             )}
//                                             {mediaType === "Video" && (
//                                                 <span className="text-red-500 font-medium">
//                                                     Max Video Size 20MB
//                                                 </span>
//                                             )}
//                                             {mediaType === "document" && (
//                                                 <span className="text-red-500 font-medium">
//                                                     PDF, DOC, DOCX allowed
//                                                 </span>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className='mt-2 w-[100%]'>
//                                 <div className='bg-[#edf1f5] rounded-[5px] py-1 px-2 w-[120px] flex justify-center mb-2'>
//                                     <span className='text-[12px]  font-semibold'> <span className='text-[#535252]'>Header •</span> Optional</span>
//                                 </div>
//                                 <div className='w-[100%] flex justify-end mt-[-15px]'>
//                                     <span className='text-[10px] font-semibold text-[#888686]'> {headervalue.length}/60</span>
//                                 </div>
//                                 <input className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]' type="text"
//                                     placeholder='Add a short line of text to the header of your message in English'
//                                     value={headervalue}
//                                     onChange={(e) => {
//                                         setheadervalue(e.target.value);
//                                     }}
//                                     onBlur={() => {
//                                         setheadervalue((prev) => normalizeVariables(prev));
//                                     }}
//                                     maxLength={60}
//                                 />
//                             </div>
//                             <div className='flex justify-end w-[100%]'>
//                                 <button
//                                     onClick={() => addVariable(headervalue, setheadervalue)}
//                                     className="mt-2  text-[#1D9E91] font-semibold text-[12px] px-3 py-1 rounded flex items-center"
//                                 >
//                                     <IoMdAdd />
//                                     Add Variable
//                                 </button>
//                             </div>

//                             {extractVariables(headervalue).map((num) => (
//                                 <input
//                                     key={num}
//                                     placeholder={`Enter value for Header {{${num}}}`}
//                                     className="border mt-2 px-2 py-1 w-full text-[12px] rounded"
//                                     value={headerVars[num] || ""}
//                                     onChange={(e) =>
//                                         setHeaderVars({
//                                             ...headerVars,
//                                             [num]: e.target.value,
//                                         })
//                                     }
//                                 />
//                             ))}
//                             <div className='mt-8 w-[100%] relative'>
//                                 <div className='bg-[#edf1f5] rounded-[5px] py-1 px-2 w-[50px] flex justify-center mb-2'>
//                                     <span className='text-[12px]  font-semibold'> Body</span>
//                                 </div>
//                                 <div className='w-[100%] flex justify-end mt-[-15px]'>
//                                     <span className='text-[10px] font-semibold text-[#888686]'> {bodyvalue.length}/1024</span>
//                                 </div>
//                                 <textarea className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]' type="text"
//                                     placeholder='E.g :- Hello {{1}}, your code will expire in {{2}} mins.'
//                                     value={bodyvalue}
//                                     onChange={(e) => setbodyvalue(e.target.value)}
//                                     maxLength={1024}
//                                     rows={4}
//                                 />

//                                 {showPicker && (
//                                     <div
//                                         ref={emojiRef}
//                                         className=' absolute bottom-0 right-0'>
//                                         <EmojiPicker onEmojiClick={handleEmojiClick} />
//                                     </div>
//                                 )}

//                             </div>
//                             <div className='flex justify-end w-[100%]'>

//                                 <button
//                                     onClick={() => setShowPicker(!showPicker)}
//                                     className="mt-2 text-white rounded"
//                                 >
//                                     😀
//                                 </button>
//                                 <button
//                                     onClick={() => addVariable(bodyvalue, setbodyvalue)}
//                                     className="mt-2  text-[#1D9E91] font-semibold text-[12px] px-3 py-1 rounded flex items-center"
//                                 >
//                                     <IoMdAdd />
//                                     Add Variable
//                                 </button>
//                             </div>
//                             {extractVariables(bodyvalue).map((num) => (
//                                 <input
//                                     key={num}
//                                     placeholder={`Enter value for  Body{{${num}}}`}
//                                     className="border mt-2 px-2 py-1 w-full text-[12px] rounded"
//                                     value={bodyVars[num] || ""}
//                                     onChange={(e) =>
//                                         setBodyVars({
//                                             ...bodyVars,
//                                             [num]: e.target.value,
//                                         })
//                                     }
//                                 />
//                             ))}
//                             <div className='mt-2 w-[100%]'>
//                                 <div className='bg-[#edf1f5] rounded-[5px] py-1 px-2 w-[120px] flex justify-center mb-2'>
//                                     <span className='text-[12px]  font-semibold'> <span className='text-[#535252]'>Footer •</span> Optional</span>
//                                 </div>
//                                 <div className='w-[100%] flex justify-end mt-[-15px]'>
//                                     <span className='text-[10px] font-semibold text-[#888686]'> {footervalue.length}/60</span>
//                                 </div>
//                                 <input className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]' type="text"
//                                     placeholder='Add a short line of text to the header of your message in English'
//                                     value={footervalue}
//                                     onChange={(e) => setfootervalue(e.target.value)}
//                                     maxLength={60}
//                                 />
//                             </div>


//                         </div>
//                         <div className='w-[100%] flex-wrap flex justify-between items-center shadow-[0_2px_6px_rgba(0,0,0,0.1)] p-4 rounded-md  mt-4 '>
//                             <div className='bg-[#edf1f5] rounded-[5px] py-1 px-2 w-[120px] flex justify-center mb-2'>
//                                 <span className='text-[12px]  font-semibold'> <span className='text-[#535252]'>Button  •</span> Optional</span>
//                             </div>
//                             <p className='text-[11px] text-[#535252d7]'> Create buttons that let customers respond to your message or take action. You can add up to ten buttons. If you add more than three buttons, they will appear in a list.</p>

//                             <button
//                                 ref={addbutton}
//                                 onClick={handleToggle}
//                                 className='flex items-center gap-1 bg-[#edf1f5] p-2 text-[11px] font-semibold mt-3  text-[#535252] relative'>
//                                 <IoMdAdd /> Add button <IoIosArrowDown />
//                                 {showaddbutton && (
//                                     <div className={`w-full md:w-[150px] absolute ${openUpward ? "bottom-full mb-1" : "top-full mt-1"
//                                         } left-0 z-50 bg-white shadow-md rounded`}>

//                                         {/* OPTIONS */}
//                                         <div
//                                             onClick={() => {
//                                                 setshowaddbutton(false);
//                                                 setcustom(true)
//                                             }}
//                                             className='py-2 flex pl-4 bg-[#f6f9fc]'
//                                         >
//                                             <label className='ml-2 font-semibold flex items-center gap-1'>  <BiSolidShare /> Custom</label>
//                                         </div>

//                                         <div
//                                             onClick={() => {
//                                                 setshowaddbutton(false);
//                                                 setvisitwebsite(true)
//                                             }}
//                                             className='py-2 flex pl-4'
//                                         >
//                                             <label className='ml-2 flex items-center gap-1 font-semibold'>
//                                                 <LuSquareArrowOutUpRight /> Visit Website
//                                             </label>
//                                         </div>

//                                         <div
//                                             onClick={() => {
//                                                 setshowaddbutton(false);

//                                             }}
//                                             className='py-2 flex pl-4 bg-[#f6f9fc]'
//                                         >
//                                             <label className='ml-2 flex items-center gap-1 font-semibold'>
//                                                 <FaWhatsapp /> call on whatsapp
//                                             </label>
//                                         </div>

//                                         <div
//                                             onClick={() => {
//                                                 setshowaddbutton(false);
//                                                 setcallphone(true)
//                                             }}
//                                             className='py-2 flex pl-4'
//                                         >

//                                             <label className='ml-2 flex items-center gap-1 font-semibold'>
//                                                 <IoCall /> Call Phone Number
//                                             </label>
//                                         </div>

//                                         <div
//                                             onClick={() => {
//                                                 setmediadropdown(false);

//                                             }}
//                                             className='py-2 flex pl-4 bg-[#f6f9fc]'
//                                         >
//                                             <label className='ml-2 flex items-center gap-1 font-semibold'>
//                                                 <FaClipboardCheck /> Complete Flow
//                                             </label>
//                                         </div>
//                                         <div
//                                             onClick={() => {
//                                                 setmediadropdown(false);
//                                                 setcopyoffercode(true)
//                                             }}
//                                             className='py-2 flex pl-4 '
//                                         >
//                                             <label className='ml-2 flex items-center gap-1 font-semibold'>
//                                                 <FaCopy />  Copy offer Code
//                                             </label>
//                                         </div>
//                                     </div>
//                                 )}
//                             </button>
//                             {custom && (
//                                 <div className='w-[100%] flex items-center justify-between mt-4 border-[#d4cfcf] border-[1px] p-3 rounded-md '>
//                                     <div className='flex gap-2'>
//                                         <div>
//                                             <label className='text-[#000] w-[100%] flex justify-between text-[12px] font-semibold dark:text-[#fff] mb-1' htmlFor=""> Type</label>
//                                             <select
//                                                 value={customvalueType}
//                                                 onChange={(e) => {
//                                                     const type = e.target.value;
//                                                     setcustomvalueType(type);
//                                                     if (type === 'custom') {
//                                                         setcustomvalue('Quick Reply');
//                                                     } else if (type === 'Preconfigured') {
//                                                         setcustomvalue('Configured response');
//                                                     }
//                                                 }}
//                                                 className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                             >
//                                                 <option value="custom">Custom</option>
//                                                 <option value="Preconfigured">Pre-configured response</option>
//                                             </select>
//                                         </div>
//                                         <div>
//                                             <label className='text-[#000] w-[100%] flex justify-between text-[12px] font-semibold dark:text-[#fff] mb-1'
//                                                 htmlFor=""> Button text <span className='text-[10px] text-[#4d4b4b]'>{customvalue.length}/25</span></label>
//                                             <input
//                                                 type="text"
//                                                 value={customvalue}
//                                                 onChange={(e) => setcustomvalue(e.target.value)}
//                                                 maxLength={25}
//                                                 className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                             />
//                                         </div>
//                                     </div>
//                                     <RxCross1
//                                         onClick={() => setcustom(false)}
//                                     />
//                                 </div>
//                             )}
//                             {visitwebsite && (
//                                 <div className='w-[100%] flex items-center justify-between mt-4 border-[#d4cfcf] border-[1px] p-3 rounded-md '>
//                                     <div className='flex gap-2 w-[100%]'>
//                                         <div>
//                                             <label className='text-[#000] w-[100%] flex justify-between text-[12px] font-semibold dark:text-[#fff] mb-1' htmlFor=""> Button text</label>
//                                             <input
//                                                 type="text"
//                                                 value={visitwebsiteText}
//                                                 onChange={(e) => setvisitwebsitetext(e.target.value)}
//                                                 className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                             />
//                                         </div>
//                                         <div>
//                                             <label className='text-[#000] w-[100%] flex justify-between text-[12px] font-semibold dark:text-[#fff] mb-1' htmlFor=""> URL type</label>
//                                             <select
//                                                 value={visitwebsiteURLtype}
//                                                 onChange={(e) => {
//                                                     const type = e.target.value;
//                                                     setvisitwebsiteURLtype(type);
//                                                     if (type === 'static') {
//                                                         setvisitwebsiteURL('static');
//                                                     } else if (type === 'Dynamic') {
//                                                         setvisitwebsiteURL('#');
//                                                     }
//                                                 }}
//                                                 className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                             >
//                                                 <option value="Static">Static</option>
//                                                 <option value="Dynamic">Dynamic</option>
//                                             </select>
//                                         </div>
//                                         <div className='w-[50%]'>
//                                             <label className='text-[#000] w-[80%] flex justify-between text-[12px] font-semibold dark:text-[#fff] mb-1' htmlFor=""> Website URL <span className='text-[10px] text-[#4d4b4b]'>{visitwebsiteURL.length}/2000</span> </label>
//                                             <input
//                                                 type="text"
//                                                 value={visitwebsiteURL}
//                                                 onChange={(e) => setvisitwebsiteURL(e.target.value)}
//                                                 maxLength={2000}
//                                                 className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[80%]'
//                                             />
//                                         </div>
//                                     </div>
//                                     <RxCross1
//                                         onClick={() => setvisitwebsite(false)}
//                                     />
//                                 </div>
//                             )}
//                             {callphone && (
//                                 <div className='w-[100%] flex items-center justify-between mt-4 border-[#d4cfcf] border-[1px] p-3 rounded-md '>
//                                     <div className='flex gap-2 w-[100%]'>
//                                         <div>
//                                             <label className='text-[#000] w-[100%] flex justify-between text-[12px] font-semibold dark:text-[#fff] mb-1' htmlFor=""> Button text</label>
//                                             <input
//                                                 type="text"
//                                                 value={callphonebtntext}
//                                                 onChange={(e) => setcallphonebtntext(e.target.value)}
//                                                 className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                             />
//                                         </div>
//                                         <div>
//                                             <label className='text-[#000] w-[100%] flex justify-between text-[12px] font-semibold dark:text-[#fff] mb-1' htmlFor=""> Country</label>
//                                             <select
//                                                 value={countrycodetype}
//                                                 onChange={(e) => {
//                                                     const type = e.target.value;
//                                                     setcountrycodetype(type);
//                                                     if (type === 'IN+91') {
//                                                         setcountrycode('+91');
//                                                     } else if (type === 'UK+44') {
//                                                         setcountrycode('+44');
//                                                     }
//                                                     else if (type === 'US+1') {
//                                                         setcountrycode('+1');
//                                                     }
//                                                 }}
//                                                 className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] '
//                                             >
//                                                 <option value="IN+91">IN+91</option>
//                                                 <option value="UK+44">UK+44</option>
//                                                 <option value="US+1">US+1</option>
//                                             </select>
//                                         </div>
//                                         <div className='w-[50%]'>
//                                             <label className='text-[#000] w-[80%] flex justify-between text-[12px] font-semibold dark:text-[#fff] mb-1' htmlFor="">Phone number <span className='text-[10px] text-[#4d4b4b]'>{visitwebsiteURL.length}/20</span> </label>
//                                             <div className='flex text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[80%]'>
//                                                 {countrycode}
//                                                 <input
//                                                     type="text"
//                                                     value={phonenumber}
//                                                     onChange={(e) => setphonenumber(e.target.value)}
//                                                     maxLength={20}
//                                                     className='outline-none ml-2'
//                                                 />
//                                             </div>

//                                         </div>
//                                     </div>
//                                     <RxCross1
//                                         onClick={() => setcallphone(false)}
//                                     />
//                                 </div>
//                             )}
//                             {copyoffercode && (
//                                 <div className='w-[100%] flex items-center justify-between mt-4 border-[#d4cfcf] border-[1px] p-3 rounded-md '>
//                                     <div className='flex gap-2 w-[100%]'>
//                                         <div>
//                                             <label className='text-[#000] w-[100%] flex justify-between text-[12px] font-semibold dark:text-[#fff] mb-1' htmlFor=""> Button text</label>
//                                             <input
//                                                 type="text"
//                                                 value={copybtntext}
//                                                 className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                             />
//                                         </div>

//                                         <div className='w-[50%]'>
//                                             <label className='text-[#000] w-[80%] flex justify-between text-[12px] font-semibold dark:text-[#fff] mb-1' htmlFor="">Offer code  </label>
//                                             <div className='flex text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[80%] justify-between'>

//                                                 <input
//                                                     type="text"
//                                                     value={offercode}
//                                                     onChange={(e) => setoffercode(e.target.value)}
//                                                     maxLength={15}
//                                                     className='outline-none ml-2'
//                                                 />
//                                                 <span> {offercode.length}/15</span>

//                                             </div>

//                                         </div>
//                                     </div>
//                                     <RxCross1
//                                         onClick={() => setcopyoffercode(false)}
//                                     />
//                                 </div>
//                             )}

//                             <div>

//                             </div>
//                         </div>
//                         <div className='w-[100%] mt-4 border-[#d4cfcf] border-[1px] p-3 rounded-md '>
//                             <h6 className='text-[14px] text-[#000] font-semibold'>Message validity period</h6>
//                             <p className='text-[11px] text-[#535252d7]'>You can set a custom validity period that your marketing message must be delivered by before it expires. If a message is not delivered within this time frame, you will not be charged and your customer will not see the message.
//                             </p>
//                             <div className='w-[100%] flex justify-between items-center  mt-4 border-[#d4cfcf] border-[1px] p-2 rounded-md '>
//                                 <div>
//                                     <h6 className='text-[14px] text-[#000] font-semibold'>Set custom validity period for your message</h6>
//                                     <p className='text-[11px] text-[#535252d7]'>If you don't set a custom validity period, the standard 10 minutes WhatsApp message validity period will be applied.
//                                     </p>
//                                 </div>
//                                 <button
//                                     onClick={() => setisActive(!isActive)}
//                                     className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${isActive ? "bg-[#37715d]" : "bg-[#b4bbc3]"}`}>
//                                     <div
//                                         className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${isActive ? "translate-x-[13px]" : ""}`}>
//                                     </div>
//                                 </button>
//                             </div>
//                             {isActive &&
//                                 <div className='w-[100%]  flex flex-col gap-1 mt-4'>
//                                     <label className='text-[#000] flex gap-1 items-center text-[12px] font-semibold dark:text-[#fff]'>Validity period  <BsInfoCircle />
//                                     </label>
//                                     <select
//                                         value={Validity}
//                                         onChange={(e) => setValidity(e.target.value)}
//                                         className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 dark:bg-[#121519] dark:text-[#fff] w-[100%]'>
//                                         <option value="43200" selected="">12 hours</option>
//                                         <option value="86400">24 hours</option>
//                                         <option value="172800">48 hours</option>
//                                         <option value="259200">72 hours</option>
//                                         <option value="345600">96 hours</option>
//                                         <option value="604800">168 hours (7 days)</option>
//                                     </select>
//                                 </div>
//                             }

//                         </div>
//                     </div>

//                     <div className='w-[100%] md:w-[26%] sm:mt-[-40px] mt-[50px] p-4 flex flex-col justify-center  relative md:fixed md:top-[100px] md:right-0  '>
//                         <div className='scale-[0.85] origin-top pb-3'>
//                             <div
//                                 className='w-[300px] bg-cover bg-center h-[600px] flex justify-center items-center  '
//                                 style={{ backgroundImage: `url(${whatsappBgimage})` }}>
//                                 <div className='w-[266.5px] bg-cover bg-center bg-no-repeat bg-[#efeae2]  h-[570px] rounded-[40px]    '
//                                     style={{
//                                         backgroundImage: `url(${whatsappBodyBgimage})`
//                                     }}>
//                                     <div className='bg-[#00816a] h-[75px] w-[100%] rounded-t-[20px] ml-[.5px]  relative overflow-hidden  '>
//                                         <div className='w-[100%] flex justify-between px-2'>
//                                             <div className='flex items-center gap-2 text-[12px] text-[#fff]'>
//                                                 <span>12:00</span>
//                                                 <FaWhatsapp />
//                                                 <FaInstagram />
//                                             </div>
//                                             <img src={whatsappnotch} alt="" className='w-[100px] h-[20px] object-content mt-[-10px] ' />
//                                             <div className='flex items-center gap-2 text-[12px] text-[#fff]'>
//                                                 <FaWifi />
//                                                 <MdOutlineSignalCellularConnectedNoInternet4Bar />
//                                                 <MdBatteryFull />
//                                             </div>
//                                         </div>
//                                         <div className='w-[100%] flex px-2 items-center  justify-between py-1 gap-1'>
//                                             <div className='flex items-center text-[#fff] gap-1'>
//                                                 <FaArrowLeftLong className='text-[28px]' />
//                                                 <img src={Whatsappicon} alt="" className='w-10 h-10' />
//                                                 <div className='flex flex-col '>
//                                                     <span className='text-[12px] text-wrap text-[#fff] font-bold'>
//                                                         {whatsappData.find((data) => data.waba_id === selectedWabaId)?.["Display Name"] ?? ''}
                                                   
//                                                     </span>
//                                                     <span className='text-[10px] text-wrap text-[#fff]'>Business Account</span>
                                               
//                                                 </div>
//                                             </div>
//                                             <div className='flex flex-col gap-1 text-[#fff]'>
//                                                 <FaShop />
//                                                 <RxDotsVertical />
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className=' w-[100%] p-2 h-[500px] flex flex-col items-baseline justify-between'>

//                                         <div className='bg-[#fff] w-[90%] p-1 rounded-lg pb-2 '>
//                                             <span className='text-[#1a1919] text-[13px]  text-wrap break-words font-bold'>{previewText(headervalue, headerVars)}</span>
//                                             <p style={{ whiteSpace: "pre-line" }} className='text-[#1a1919] text-[12px] font-semibold text-wrap break-words mt-1'>{bodyvalue}</p>
//                                             <span className='text-[#1a1919] text-[12px]  text-wrap break-words '>{footervalue}</span>
//                                             <div className='w-[100%] flex items-center justify-center'>{
//                                                 custom &&
//                                                 <button className='text-[12px] flex gap-1 items-center font-semibold text-[#1D9E91] mt-1'><BiSolidShare />{customvalue}</button>
//                                             }

//                                             </div>
//                                             <div className='w-[100%] flex items-center justify-center'>{
//                                                 visitwebsite &&
//                                                 <Link to={visitwebsiteURL}>
//                                                     <button className='text-[12px] flex gap-1 items-center font-semibold text-[#1D9E91] mt-1 '><BiSolidShare />{visitwebsiteText}</button>
//                                                 </Link>
//                                             }
//                                             </div>
//                                             <div className='w-[100%] flex items-center justify-center'>{
//                                                 callphone &&
//                                                 <button className='text-[12px] flex gap-1 items-center font-semibold text-[#1D9E91] mt-1'><IoCall />{callphonebtntext}</button>
//                                             }

//                                             </div>
//                                         </div>
//                                         <div className='w-[100%] flex justify-between items-center gap-1'>
//                                             <div className='bg-[#fff] flex justify-between px-2 py-3 rounded-lg w-[90%]'>
//                                                 <div className='flex items-center gap-2'>
//                                                     <CiFaceSmile />
//                                                     <span className='text-[#575656] text-[12px]'>Enter your message</span>
//                                                 </div>
//                                                 <div className='flex items-center gap-2 text-[#575656]'>
//                                                     <FaPaperclip />
//                                                     <FaCamera />
//                                                 </div>
//                                             </div>
//                                             <div className='bg-[#448c71] h-[30px] w-[30px] rounded-full flex justify-center items-center text-[#fff]'>
//                                                 <FaMicrophone />
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className='flex w-[70%] justify-center mt-2 mb-2 gap-2' >
//                                 <button
//                                     onClick={() => setopen(!open)}
//                                     className='p-2 bg-[#d3dde6] rounded-md text-[14px] font-semibold '>Previous</button>
//                                 <button
//                                     onClick={addtemplate}
//                                     className='p-2 bg-[#00816a] rounded-md text-[14px] font-semibold text-[#fff] '>Submit for Review</button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <Gobackmodal isOpen={open} onClose={() => setopen(false)} heading='Change will be lost if you go back'>
//                     <div className='py-2 border-y-[1px] border-[#8b8a8a67] my-2'>
//                         <p className='text-[10px] text-[#646262]'>You start editing this template but haven't submitted it yet. If you Discard now,allow of your changes will be lost</p>
//                     </div>
//                     <div className='w-[100%] flex justify-end gap-1'>
//                         <button
//                             onClick={() => setopen(!open)}
//                             className='p-2 bg-[#d3dde6] rounded-md text-[12px] font-semibold text-[#555555]  '>Continue</button>

//                         <Link to='/WAMessage/WATemplate/SetupTemplate'>
//                             <button
//                                 className='p-2 bg-[#00816a] rounded-md text-[12px] font-semibold text-[#fff] '>Go Back</button>
//                         </Link>
//                     </div>
//                 </Gobackmodal>
//             </div>
//         </>
//     )
// }

// export default Edittemplate

import React, { useState, useRef, useEffect } from 'react'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Link } from 'react-router-dom';
import EmojiPicker from "emoji-picker-react";
import useClickOutside from './coutomclickhooks';
import axios from "axios";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaWhatsapp } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaWifi } from "react-icons/fa";
import { MdOutlineSignalCellularConnectedNoInternet4Bar } from "react-icons/md";
import { MdBatteryFull } from "react-icons/md";
import { FaShop } from "react-icons/fa6";
import { RxDotsVertical } from "react-icons/rx";
import { CiFaceSmile } from "react-icons/ci";
import { FaPaperclip } from "react-icons/fa";
import { FaCamera } from "react-icons/fa";
import { FaMicrophone } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosVideocam } from "react-icons/io";
import { IoDocumentTextOutline } from "react-icons/io5";
import { ImLocation } from "react-icons/im";
import { IoMdAdd } from "react-icons/io";
import { FaPhotoVideo } from "react-icons/fa";
import { BiSolidShare } from "react-icons/bi";
import { LuSquareArrowOutUpRight } from "react-icons/lu";
import { IoCall } from "react-icons/io5";
import { FaClipboardCheck } from "react-icons/fa6";
import { FaCopy } from "react-icons/fa";
import { RxCross1 } from "react-icons/rx";
import { BsInfoCircle } from "react-icons/bs";

import whatsappnotch from '../images/Wp-notch-image.png'
import Whatsappicon from '../images/Whatsappicon.png'
import whatsappBgimage from '../images/whatsapp-mobile-image.png'
import whatsappBodyBgimage from '../images/whatsappBackground.jpg'
import Gobackmodal from './gobackmodal';

const API_URL = process.env.REACT_APP_API_URL || "https://wa-api.globebot.io";

function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
        );
        return JSON.parse(jsonPayload);
    } catch { return {}; }
}

function getUserIdFromToken() {
    if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
        const rawToken = window.locatorgarsotrga("token");
        if (rawToken) {
            const decoded = decodeToken(rawToken);
            return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
        }
    }
    const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (rawToken) {
        const decoded = decodeToken(rawToken);
        return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
    }
    return { userId: null, token: null };
}

function Edittemplate({ setActive }) {
    let param = useParams();
    const navigate   = useNavigate();
    const location   = useLocation();
    const params     = new URLSearchParams(location.search);
    const { activetab, choosetemplate } = location.state || {};
    const Datatext   = params.get("text") || "";
    const templatenametext   = params.get("name") || "";
    const partempid = params.get("templateId") || "";

    const dropdownRef = useRef(null);
    const emojiRef    = useRef(null);
    const addbutton   = useRef(null);
    useClickOutside([dropdownRef, emojiRef, addbutton], () => {
        setmediadropdown(false);
        setShowPicker(false);
        setshowaddbutton(false);
    });

    const { token } = getUserIdFromToken();

    // ── Form state ────────────────────────────────────────────────────────
    const [templateName,       settemplateName]       = useState(templatenametext);
    const [selectedLanguage,   setSelectedLanguage]   = useState('en_US');
    const [selectedWabaId,     setSelectedWabaId]     = useState('');
    const [showmedia,          setshowmedia]          = useState('none');
    const [mediadropdown,      setmediadropdown]      = useState(false);
    const [mediavalue,         setmediavalue]         = useState('none');
    const [mediaType,          setMediaType]          = useState('none');
    const [headervalue,        setheadervalue]        = useState('Hello');
    const [bodyvalue,          setbodyvalue]          = useState(Datatext);
    const [footervalue,        setfootervalue]        = useState('');
    const [headerVars,         setHeaderVars]         = useState({});
    const [bodyVars,           setBodyVars]           = useState({});
    const [showPicker,         setShowPicker]         = useState(false);
    const [showaddbutton,      setshowaddbutton]      = useState(false);
    const [openUpward,         setOpenUpward]         = useState(false);
    const [customvalue,        setcustomvalue]        = useState('Quick Reply');
    const [customvalueType,    setcustomvalueType]    = useState('custom');
    const [custom,             setcustom]             = useState(false);
    const [visitwebsite,       setvisitwebsite]       = useState(false);
    const [visitwebsiteText,   setvisitwebsitetext]   = useState('Visit website');
    const [visitwebsiteURL,    setvisitwebsiteURL]    = useState('');
    const [visitwebsiteURLtype,setvisitwebsiteURLtype]= useState('Static');
    const [callphone,          setcallphone]          = useState(false);
    const [callphonebtntext,   setcallphonebtntext]   = useState('Call phone');
    const [phonenumber,        setphonenumber]        = useState('');
    const [countrycode,        setcountrycode]        = useState('+91');
    const [countrycodetype,    setcountrycodetype]    = useState('IN+91');
    const [copyoffercode,      setcopyoffercode]      = useState(false);
    const [offercode,          setoffercode]          = useState('');
    const [copybtntext,        setcopybtntext]        = useState('Copy offer code');
    const [isActive,           setisActive]           = useState(false);
    const [Validity,           setValidity]           = useState('');
    const [open,               setopen]               = useState(false);

    // ── Submission state ──────────────────────────────────────────────────
    const [submitting,    setSubmitting]    = useState(false);
    const [submitResult,  setSubmitResult]  = useState(null); // { success, message, template_id }
    const [submitError,   setSubmitError]   = useState(null);

    // ── WhatsApp accounts ─────────────────────────────────────────────────
    const [whatsappData, setWhatsappData] = useState([]);

    // ── Fetch and fill template if partempid is present ──────────────────
    useEffect(() => {
        const fetchTemplateDetails = async () => {
            if (!partempid) return;
            try {
                const headers = token ? { Authorization: `${token}` } : {};
                // Note: Using /auth/template/:templateId API route
                const res = await axios.get(`${API_URL}/auth/template/templateId/${partempid}`, { headers });
                if (res.data && res.data.success && res.data.data) {
                    const tpl = res.data.data;
                    settemplateName(tpl.name || '');
                    setSelectedLanguage(tpl.language || 'en_US');
                    setSelectedWabaId(tpl.waba_id || '');
                    // Parse components
                    if (Array.isArray(tpl.components)) {
                        const headerComp = tpl.components.find(c => c.type === 'HEADER');
                        const bodyComp   = tpl.components.find(c => c.type === 'BODY');
                        const footerComp = tpl.components.find(c => c.type === 'FOOTER');
                        setheadervalue(headerComp?.text || '');
                        setbodyvalue(bodyComp?.text || '');
                        setfootervalue(footerComp?.text || '');
                        // You can extract headerVars and bodyVars from component texts if needed here
                        if (bodyComp?.text) {
                            // Example simple extraction, adapt as needed
                            setBodyVars({});
                        }
                        if (headerComp?.text) {
                            setHeaderVars({});
                        }
                        // For media type, etc. can be adapted if component structure includes it
                    }
                    // Fill button/phone/URL from BUTTONS type
                    const buttonsComp = tpl.components.find(c => c.type === 'BUTTONS');
                    if (buttonsComp && Array.isArray(buttonsComp.buttons) && buttonsComp.buttons.length > 0) {
                        // We'll only map what matches our UI state – e.g., call/URL, button text, phone
                        const phoneBtn = buttonsComp.buttons.find(btn => btn.type === "PHONE_NUMBER");
                        if (phoneBtn) {
                            setcallphone(true);
                            setcallphonebtntext(phoneBtn.text || 'Call phone');
                            setphonenumber(phoneBtn.phone_number || '');
                        }
                        // Add handling for URL or COPY if relevant button types are present
                        const urlBtn = buttonsComp.buttons.find(btn => btn.type === "URL");
                        if (urlBtn) {
                            setvisitwebsite(true);
                            setvisitwebsitetext(urlBtn.text || 'Visit website');
                            setvisitwebsiteURL(urlBtn.url || '');
                        }
                        // No direct offer/copy found in this schema example, but handle as needed.
                    }
                    // Apply other values from base fields if present
                    setValidity(tpl.validity || ''); // if field exists
                    setisActive(Boolean(tpl.is_active));
                }
            } catch (err) {
                setSubmitError("Unable to fetch template details");
            }
        };

        fetchTemplateDetails();
        // eslint-disable-next-line
    }, [partempid, token]);

    useEffect(() => {
        const fetchWhatsappData = async () => {
            try {
                const headers = token ? { Authorization: `${token}` } : {};
                const response = await axios.get(`${API_URL}/auth/my-whatsapp`, { headers });
                setWhatsappData(Array.isArray(response.data) ? response.data : []);
            } catch { setWhatsappData([]); }
        };
        fetchWhatsappData();
    }, [token]);

    // ── Helpers ───────────────────────────────────────────────────────────
    const extractVariables = (text) => {
        const matches = text.match(/{{(\d+)}}/g) || [];
        return [...new Set(matches.map(m => m.replace(/[{}]/g, "")))];
    };

    const previewText = (text, variables) =>
        text.replace(/{{(\d+)}}/g, (_, key) => variables[key] || `{{${key}}}`);

    const addVariable = (value, setValue) => {
        const numbers = (value.match(/{{(\d+)}}/g) || []).map(m => m.replace(/[{}]/g, ""));
        let next = 1;
        while (numbers.includes(String(next))) next++;
        setValue(value.trimEnd() + ` {{${next}}}`);
    };

    const normalizeVariables = (text) => {
        let count = 1, map = {};
        return text.replace(/{{(\d+)}}/g, (_, num) => {
            if (!map[num]) { map[num] = count; count++; }
            return `{{${map[num]}}}`;
        });
    };

    const handleEmojiClick = (emojiData) => setbodyvalue(prev => prev + emojiData.emoji);

    // ── Meta variable ratio check (error_subcode 2388293) ────────────────
    // Meta rejects templates where variables make up >= 50% of the text.
    // Each {{n}} counts as ~4 chars, the rest is literal text.
    // We warn if literal text < total length * 0.5
    function checkVariableRatio(text) {
        if (!text) return { ok: true };
        const varMatches  = text.match(/{{\d+}}/g) || [];
        const varCharCount = varMatches.length * 4;          // each {{n}} ≈ 4 chars
        const totalChars   = text.length;
        const literalChars = totalChars - varCharCount;
        if (totalChars === 0) return { ok: true };
        const ratio = varCharCount / totalChars;
        // Warn above 40%, hard-block above 50%
        if (ratio >= 0.5)  return { ok: false, hard: true,  ratio, literalChars };
        if (ratio >= 0.4)  return { ok: false, hard: false, ratio, literalChars };
        return { ok: true, ratio };
    }

    const getAcceptType = () => {
        switch (mediaType) {
            case "image":    return "image/*";
            case "video":    return "video/*";
            case "document": return ".pdf,.doc,.docx";
            default:         return "*";
        }
    };

    const handleToggle = () => {
        const rect = addbutton.current.getBoundingClientRect();
        setOpenUpward(window.innerHeight - rect.bottom < 200);
        setshowaddbutton(!showaddbutton);
    };

    // ── Build buttons array for API ───────────────────────────────────────
    function buildButtons() {
        const buttons = [];
        if (custom) {
            buttons.push({
                type: customvalueType === 'custom' ? 'QUICK_REPLY' : 'QUICK_REPLY',
                text: customvalue,
            });
        }
        if (visitwebsite) {
            buttons.push({
                type: 'URL',
                text: visitwebsiteText,
                url:  visitwebsiteURL,
            });
        }
        if (callphone) {
            buttons.push({
                type:         'PHONE_NUMBER',
                text:         callphonebtntext,
                phone_number: countrycode + phonenumber,
            });
        }
        if (copyoffercode) {
            buttons.push({
                type:    'COPY_CODE',
                example: offercode,
            });
        }
        return buttons;
    }

    // ── Submit for Review → Meta ──────────────────────────────────────────
    const submitTemplate = async () => {
        setSubmitResult(null);
        setSubmitError(null);

        // Validate required fields
        if (!templateName.trim()) {
            setSubmitError("Please enter a template name.");
            return;
        }
        if (!selectedWabaId) {
            setSubmitError("Please select a WABA account.");
            return;
        }
        if (!bodyvalue.trim()) {
            setSubmitError("Body text is required.");
            return;
        }

        // ── Check Meta variable ratio rule ────────────────────────────────
        const bodyRatio = checkVariableRatio(bodyvalue);
        if (bodyRatio.hard) {
            setSubmitError(
                `Body has too many variables for its length (${Math.round(bodyRatio.ratio * 100)}% variable content). ` +
                `Meta requires variables to be less than 50% of the text. ` +
                `Add more literal text or reduce variables. ` +
                `Current literal characters: ${bodyRatio.literalChars}.`
            );
            return;
        }

        const headerRatio = checkVariableRatio(headervalue);
        if (headerRatio.hard) {
            setSubmitError(
                `Header has too many variables for its length. Add more literal text around the variables.`
            );
            return;
        }

        setSubmitting(true);

        try {
            const headers = token ? { Authorization: `${token}`, "Content-Type": "application/json" } : {};

            const payload = {
                waba_id:       selectedWabaId,
                template_name: templateName.toLowerCase().replace(/\s+/g, '_'), // Meta requires snake_case
                language:      selectedLanguage,
                category:      (activetab || 'MARKETING').toUpperCase(),

                // Header
                header: mediaType === 'none'
                    ? { type: "TEXT", text: headervalue }
                    : { type: mediaType.toUpperCase() },

                // Body
                body: { text: bodyvalue },

                // Footer (optional)
                ...(footervalue.trim() && { footer: { text: footervalue } }),

                // Buttons (optional)
                ...(buildButtons().length > 0 && { buttons: buildButtons() }),

                // Validity period
                ...(isActive && Validity && { message_send_ttl_seconds: parseInt(Validity) }),
            };

            const response = await axios.post(`${API_URL}/auth/create-template`, payload, { headers });

            setSubmitResult({
                success:     true,
                template_id: response.data.template_id,
                status:      response.data.status,
                message:     `Template submitted! Status: ${response.data.status || 'PENDING'}. Meta will review within 24hrs.`,
            });

        } catch (err) {
            const errMsg = err?.response?.data?.error?.error_user_msg
                || err?.response?.data?.message
                || err?.response?.data?.error
                || err.message
                || "Failed to submit template.";
            setSubmitError(errMsg);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <div className='w-[100%] px-4'>
                {/* ── Breadcrumb tabs ── */}
                <div className='flex gap-4 border-t-[1px] border-[#cfcdcd] pt-2'>
                    <div
                        onClick={() => navigate('/WAMessage/WATemplate/SetupTemplate')}
                        className={`flex items-center gap-2 text-[12px] font-bold p-[5px] rounded-lg border-[1px] cursor-pointer
                            ${location.pathname.includes('/WAMessage/WATemplate/SetupTemplate') ? 'text-[#31b07b] border-[#31b07b]' : 'text-[#9e9d9d] border-[#9e9d9d]'}`}
                    >
                        <div className={`w-[15px] h-[15px] border-[1px] rounded-full flex justify-center items-center
                            ${location.pathname.includes('/WAMessage/WATemplate/SetupTemplate') ? 'border-[#31b07b] bg-[#31b07b]' : 'border-[#9e9d9d]'}`}>
                            {location.pathname.includes('/WAMessage/WATemplate/SetupTemplate') && <div className='w-[7px] h-[7px] bg-[#fff] rounded-full'></div>}
                        </div>
                        Set up template
                    </div>
                    <div
                        onClick={() => navigate('/WAMessage/WATemplate/AddEditTemplate')}
                        className={`flex items-center gap-2 text-[12px] font-bold p-[5px] rounded-lg border-[1px] cursor-pointer
                            ${location.pathname.includes('/WAMessage/WATemplate/AddEditTemplate') ? 'text-[#31b07b] border-[#31b07b]' : 'text-[#9e9d9d] border-[#9e9d9d]'}`}
                    >
                        <div className={`w-[15px] h-[15px] border-[1px] rounded-full flex justify-center items-center
                            ${location.pathname.includes('/WAMessage/WATemplate/AddEditTemplate') ? 'border-[#31b07b] bg-[#31b07b]' : 'border-[#9e9d9d]'}`}>
                            {location.pathname.includes('/WAMessage/WATemplate/AddEditTemplate') && <div className='w-[7px] h-[7px] bg-[#fff] rounded-full'></div>}
                        </div>
                        Edit template
                    </div>
                </div>

                {/* ── Submit result / error banner ── */}
                {submitResult?.success && (
                    <div className='w-full mt-3 p-3 bg-[#d1fae5] border border-[#6ee7b7] rounded-lg text-[#065f46] text-[13px] font-semibold flex items-center justify-between'>
                        <span>{submitResult.message}</span>
                        <button onClick={() => setSubmitResult(null)} className='ml-4 text-[#065f46] hover:text-black'><RxCross1 /></button>
                    </div>
                )}
                {submitError && (
                    <div className='w-full mt-3 p-3 bg-[#fee2e2] border border-[#fca5a5] rounded-lg text-[#991b1b] text-[13px] font-semibold flex items-center justify-between'>
                        <span>{submitError}</span>
                        <button onClick={() => setSubmitError(null)} className='ml-4 text-[#991b1b] hover:text-black'><RxCross1 /></button>
                    </div>
                )}

                <div className='w-[100%] flex flex-col md:flex-row mt-4 md:p-0 p-2'>
                    {/* ══════════ LEFT / FORM PANEL ══════════ */}
                    <div className='w-[100%] md:w-[70%] flex flex-col px-0 py-2 mb-[20px] md:mb-[0px]'>

                        {/* Template info card */}
                        <div className='w-[100%] flex-wrap flex justify-between items-center shadow-[0_2px_6px_rgba(0,0,0,0.1)] p-4 rounded-md'>
                            <div className='flex gap-4 items-center w-[100%] sm:w-[50%]'>
                                <div className='w-[35px] h-[35px] bg-[#1D9E91] flex items-center justify-center rounded-lg'>🔔</div>
                                <div>
                                    <p className='text-[14px] text-[#474646] font-semibold'>{templateName || 'your_template_name'} • {selectedLanguage}</p>
                                    <p className='text-[12px] text-[#474646]'>{activetab || 'Marketing'} • {choosetemplate || 'Default'}</p>
                                </div>
                            </div>
                            <div className='flex items-center justify-end gap-4 w-[100%] sm:w-[50%] mt-2 sm:mt-0'>
                                <label className='text-[#1D9E91] text-[14px] font-bold' htmlFor="AllowCategoryChange">Allow Category Change</label>
                                <input className='accent-[#1D9E91] w-[16px] h-[16px]' type="checkbox" id="AllowCategoryChange" />
                            </div>
                        </div>

                        {/* Template name, language, WABA */}
                        <div className='w-[100%] flex justify-between items-center shadow-[0_2px_6px_rgba(0,0,0,0.1)] p-4 rounded-md mt-4'>
                            <div className='w-[100%] flex flex-wrap gap-4'>
                                {/* Template name */}
                                <div className='w-full sm:w-[48%] md:w-[31%] flex flex-col gap-1'>
                                    <label className='text-[#000] w-[100%] flex justify-between text-[12px] font-semibold dark:text-[#fff]'>
                                        Template Name : <span className='text-[10px] font-semibold text-[#888686]'>{templateName.length}/512</span>
                                    </label>
                                    <input
                                        className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                        type="text"
                                        value={templateName}
                                        onChange={(e) => {
                                            // Replace spaces with '_' and remove non-alphabetical (except '_')
                                            let value = e.target.value.replace(/\s+/g, "_").replace(/[^a-zA-Z_]/g, "");
                                            settemplateName(value);
                                        }}
                                        placeholder='Enter a template name'
                                        maxLength={512}
                                    />
                           
                                    {!templateName.length && <span className='text-[12px] text-red-600 font-semibold'>You need to enter a name.</span>}
                                </div>

                                {/* Language */}
                                <div className='w-full sm:w-[48%] md:w-[31%] flex flex-col gap-1'>
                                    <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Select language</label>
                                    <select
                                        value={selectedLanguage}
                                        onChange={(e) => setSelectedLanguage(e.target.value)}
                                        className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 dark:bg-[#121519] dark:text-[#fff]'
                                    >
                                        <option value="sq">Albanian</option>
                                        <option value="ar">Arabic</option>
                                        <option value="bn">Bengali</option>
                                        <option value="bg">Bulgarian</option>
                                        <option value="ca">Catalan</option>
                                        <option value="zh_CN">Chinese (China)</option>
                                        <option value="zh_HK">Chinese (Hong Kong)</option>
                                        <option value="zh_TW">Chinese (Taiwan)</option>
                                        <option value="hr">Croatian</option>
                                        <option value="cs">Czech</option>
                                        <option value="da">Danish</option>
                                        <option value="nl">Dutch</option>
                                        <option value="en">English</option>
                                        <option value="en_US">English (US)</option>
                                        <option value="en_GB">English (UK)</option>
                                        <option value="en_IN">English (India)</option>
                                        <option value="fi">Finnish</option>
                                        <option value="fr">French</option>
                                        <option value="de">German</option>
                                        <option value="el">Greek</option>
                                        <option value="gu">Gujarati</option>
                                        <option value="he">Hebrew</option>
                                        <option value="hi">Hindi</option>
                                        <option value="hu">Hungarian</option>
                                        <option value="id">Indonesian</option>
                                        <option value="it">Italian</option>
                                        <option value="ja">Japanese</option>
                                        <option value="kn">Kannada</option>
                                        <option value="ko">Korean</option>
                                        <option value="ms">Malay</option>
                                        <option value="ml">Malayalam</option>
                                        <option value="mr">Marathi</option>
                                        <option value="nb">Norwegian</option>
                                        <option value="fa">Persian</option>
                                        <option value="pl">Polish</option>
                                        <option value="pt_BR">Portuguese (Brazil)</option>
                                        <option value="pt_PT">Portuguese (Portugal)</option>
                                        <option value="pa">Punjabi</option>
                                        <option value="ro">Romanian</option>
                                        <option value="ru">Russian</option>
                                        <option value="es">Spanish</option>
                                        <option value="es_MX">Spanish (Mexico)</option>
                                        <option value="sw">Swahili</option>
                                        <option value="sv">Swedish</option>
                                        <option value="ta">Tamil</option>
                                        <option value="te">Telugu</option>
                                        <option value="th">Thai</option>
                                        <option value="tr">Turkish</option>
                                        <option value="uk">Ukrainian</option>
                                        <option value="ur">Urdu</option>
                                        <option value="vi">Vietnamese</option>
                                    </select>
                                </div>

                                {/* WABA Account */}
                                <div className='w-full sm:w-[48%] md:w-[31%] flex flex-col gap-1'>
                                    <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>WABA Account</label>
                                    <select
                                        className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 dark:bg-[#121519] dark:text-[#fff]'
                                        value={selectedWabaId}
                                        onChange={(e) => setSelectedWabaId(e.target.value)}
                                    >
                                        <option value="">Select WABA Account</option>
                                        {whatsappData.map((data) => (
                                            <option key={data.waba_id} value={data.waba_id}>
                                                WB: {data.waba_id} | PI: {data["PhoneNumber Id"] || data.phone_number_id} | N: {data["WABA Number"] || data["Waba Number"] || data.phone_number || data["phone_number"]}
                                            </option>
                                       
                                        ))}
                                    </select>
                                    {!selectedWabaId && <span className='text-[12px] text-red-600 font-semibold'>Please select a WABA account.</span>}
                                </div>
                            </div>
                        </div>

                        {/* Media + Header + Body + Footer */}
                        <div className='w-[100%] shadow-[0_2px_6px_rgba(0,0,0,0.1)] p-4 rounded-md mt-4'>
                            <div className='flex flex-col md:flex-row w-full gap-4'>
                                {/* Media selector */}
                                <div className='w-full md:w-[40%]'>
                                    <div className='bg-[#edf1f5] rounded-[5px] py-1 px-2 w-fit flex justify-center'>
                                        <span className='text-[12px] font-semibold'><span className='text-[#535252]'>Media sample •</span> Optional</span>
                                    </div>
                                    <div ref={dropdownRef} onClick={() => setmediadropdown(!mediadropdown)}
                                        className='w-full md:w-[300px] border border-[#d4cfcf] rounded-md mt-4 flex justify-between items-center text-[12px] p-2 text-[#454546] relative'>
                                        <div className='w-full flex justify-between items-center'>
                                            <span className='font-semibold'>{mediavalue}</span>
                                            <IoIosArrowDown />
                                        </div>
                                        {mediadropdown && (
                                            <div className='w-full md:w-[150px] absolute top-full left-0 mt-1 z-50 bg-white shadow-md rounded'>
                                                {[
                                                    { val: 'none',     label: 'None',     icon: null,                     bg: 'bg-[#f6f9fc]' },
                                                    { val: 'Image',    label: 'Image',    icon: <FaCamera />,             bg: '' },
                                                    { val: 'Video',    label: 'Video',    icon: <IoIosVideocam />,        bg: 'bg-[#f6f9fc]' },
                                                    { val: 'document', label: 'Document', icon: <IoDocumentTextOutline />,bg: '' },
                                                    { val: 'Location', label: 'Location', icon: <ImLocation />,           bg: 'bg-[#f6f9fc]' },
                                                ].map(opt => (
                                                    <div key={opt.val} onClick={() => { setmediadropdown(false); setmediavalue(opt.val); setMediaType(opt.val); }}
                                                        className={`py-2 flex pl-4 ${opt.bg}`}>
                                                        <input type="radio" checked={mediavalue === opt.val} readOnly />
                                                        <label className='ml-2 font-semibold flex items-center gap-1'>{opt.icon} {opt.label}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Upload media */}
                                <div className={`${mediaType === 'none' ? 'hidden' : 'flex'} w-full md:w-[50%] flex-col`}>
                                    <div className='bg-[#edf1f5] rounded-[5px] py-1 px-2 w-fit flex justify-center'>
                                        <span className='text-[12px] font-semibold text-[#535252]'>Upload Media</span>
                                    </div>
                                    <div className="border border-[#edf1f5] rounded text-center bg-[#f6f9fc] p-3 mt-2 w-full md:w-[70%]">
                                        <label className="cursor-pointer text-blue-500 text-[12px] flex items-center justify-center gap-1">
                                            <FaPhotoVideo /> Choose <span className="font-bold">{mediaType}</span> to upload
                                            <input type="file" name="mediaFile" className="hidden" accept={getAcceptType()} />
                                        </label>
                                        <div className="text-gray-500 text-[12px] mt-1">
                                            {mediaType === "Image"    && <span className="text-red-500 font-medium">Max Image Size 5MB</span>}
                                            {mediaType === "Video"    && <span className="text-red-500 font-medium">Max Video Size 16MB</span>}
                                            {mediaType === "document" && <span className="text-red-500 font-medium">PDF, DOC, DOCX allowed<br/><span className="text-red-500 text-[8px] font-medium">Max file Size 100MB</span></span>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Header */}
                            <div className='mt-2 w-[100%]'>
                                <div className='bg-[#edf1f5] rounded-[5px] py-1 px-2 w-[120px] flex justify-center mb-2'>
                                    <span className='text-[12px] font-semibold'><span className='text-[#535252]'>Header •</span> Optional</span>
                                </div>
                                <div className='w-[100%] flex justify-end mt-[-15px]'>
                                    <span className='text-[10px] font-semibold text-[#888686]'>{headervalue.length}/60</span>
                                </div>
                                {(() => {
                                    const r = checkVariableRatio(headervalue);
                                    if (r.ok || !headervalue) return null;
                                    return (
                                        <div className={`w-full mb-1 px-3 py-1.5 rounded-lg text-[11px] font-semibold border ${r.hard ? 'bg-[#fee2e2] border-[#fca5a5] text-[#991b1b]' : 'bg-[#fffbe6] border-[#f59e0b] text-[#856404]'}`}>
                                            {r.hard ? '❌' : '⚠️'} Header variables are {Math.round(r.ratio * 100)}% of text (limit 50%). Add more surrounding text.
                                        </div>
                                    );
                                })()}
                                <input className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]'
                                    type="text"
                                    placeholder='Add a short line of text to the header of your message'
                                    value={headervalue}
                                    onChange={(e) => setheadervalue(e.target.value)}
                                    onBlur={() => setheadervalue(prev => normalizeVariables(prev))}
                                    maxLength={60}
                                />
                            </div>
                            <div className='flex justify-end w-[100%]'>
                                <button onClick={() => addVariable(headervalue, setheadervalue)}
                                    className="mt-2 text-[#1D9E91] font-semibold text-[12px] px-3 py-1 rounded flex items-center">
                                    <IoMdAdd /> Add Variable
                                </button>
                            </div>
                            {extractVariables(headervalue).map(num => (
                                <input key={num} placeholder={`Enter value for Header {{${num}}}`}
                                    className="border mt-2 px-2 py-1 w-full text-[12px] rounded"
                                    value={headerVars[num] || ""}
                                    onChange={(e) => setHeaderVars({ ...headerVars, [num]: e.target.value })}
                                />
                            ))}

                            {/* Body */}
                            <div className='mt-8 w-[100%] relative'>
                                <div className='bg-[#edf1f5] rounded-[5px] py-1 px-2 w-[50px] flex justify-center mb-2'>
                                    <span className='text-[12px] font-semibold'>Body</span>
                                </div>
                                <div className='w-[100%] flex justify-end mt-[-15px]'>
                                    <span className='text-[10px] font-semibold text-[#888686]'>{bodyvalue.length}/1024</span>
                                </div>

                                {/* ── Variable ratio live warning ── */}
                                {(() => {
                                    const r = checkVariableRatio(bodyvalue);
                                    if (r.ok || !bodyvalue) return null;
                                    return (
                                        <div className={`w-full mb-2 px-3 py-2 rounded-lg text-[12px] font-semibold flex items-start gap-2 border ${r.hard ? 'bg-[#fee2e2] border-[#fca5a5] text-[#991b1b]' : 'bg-[#fffbe6] border-[#f59e0b] text-[#856404]'}`}>
                                            <span className='shrink-0'>{r.hard ? '❌' : '⚠️'}</span>
                                            <div>
                                                <p>{r.hard ? 'Too many variables' : 'Variable ratio warning'} — variables are {Math.round(r.ratio * 100)}% of the text (Meta limit: 50%).</p>
                                                <p className='mt-0.5 font-normal'>Add more literal text around your variables. Example: instead of <code className='bg-black bg-opacity-10 px-1 rounded'>{'{{1}}'}</code>, write <code className='bg-black bg-opacity-10 px-1 rounded'>Hello {'{{1}}'}, your order is ready.</code></p>
                                            </div>
                                        </div>
                                    );
                                })()}

                                <textarea className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]'
                                    placeholder='E.g :- Hello {{1}}, your code will expire in {{2}} mins.'
                                    value={bodyvalue}
                                    onChange={(e) => setbodyvalue(e.target.value)}
                                    maxLength={1024}
                                    rows={4}
                                />
                                {showPicker && (
                                    <div ref={emojiRef} className='absolute bottom-0 right-0'>
                                        <EmojiPicker onEmojiClick={handleEmojiClick} />
                                    </div>
                                )}
                            </div>
                            <div className='flex justify-end w-[100%]'>
                                <button onClick={() => setShowPicker(!showPicker)} className="mt-2 text-white rounded">😀</button>
                                <button onClick={() => addVariable(bodyvalue, setbodyvalue)}
                                    className="mt-2 text-[#1D9E91] font-semibold text-[12px] px-3 py-1 rounded flex items-center">
                                    <IoMdAdd /> Add Variable
                                </button>
                            </div>
                            {extractVariables(bodyvalue).map(num => (
                                <input key={num} placeholder={`Enter value for Body {{${num}}}`}
                                    className="border mt-2 px-2 py-1 w-full text-[12px] rounded"
                                    value={bodyVars[num] || ""}
                                    onChange={(e) => setBodyVars({ ...bodyVars, [num]: e.target.value })}
                                />
                            ))}

                            {/* Footer */}
                            <div className='mt-2 w-[100%]'>
                                <div className='bg-[#edf1f5] rounded-[5px] py-1 px-2 w-[120px] flex justify-center mb-2'>
                                    <span className='text-[12px] font-semibold'><span className='text-[#535252]'>Footer •</span> Optional</span>
                                </div>
                                <div className='w-[100%] flex justify-end mt-[-15px]'>
                                    <span className='text-[10px] font-semibold text-[#888686]'>{footervalue.length}/60</span>
                                </div>
                                <input className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]'
                                    placeholder='Add a short line of text to the footer of your message'
                                    value={footervalue}
                                    onChange={(e) => setfootervalue(e.target.value)}
                                    maxLength={60}
                                />
                            </div>
                        </div>

                        {/* Buttons */}
                        <div className='w-[100%] flex-wrap flex justify-between items-center shadow-[0_2px_6px_rgba(0,0,0,0.1)] p-4 rounded-md mt-4'>
                            <div className='bg-[#edf1f5] rounded-[5px] py-1 px-2 w-[120px] flex justify-center mb-2'>
                                <span className='text-[12px] font-semibold'><span className='text-[#535252]'>Button •</span> Optional</span>
                            </div>
                            <p className='text-[11px] text-[#535252d7]'>Create buttons that let customers respond or take action. Up to ten buttons allowed.</p>

                            <button ref={addbutton} onClick={handleToggle}
                                className='flex items-center gap-1 bg-[#edf1f5] p-2 text-[11px] font-semibold mt-3 text-[#535252] relative'>
                                <IoMdAdd /> Add button <IoIosArrowDown />
                                {showaddbutton && (
                                    <div className={`w-full md:w-[150px] absolute ${openUpward ? "bottom-full mb-1" : "top-full mt-1"} left-0 z-50 bg-white shadow-md rounded`}>
                                        <div onClick={() => { setshowaddbutton(false); setcustom(true); }}       className='py-2 flex pl-4 bg-[#f6f9fc]'><label className='ml-2 font-semibold flex items-center gap-1'><BiSolidShare /> Custom</label></div>
                                        <div onClick={() => { setshowaddbutton(false); setvisitwebsite(true); }}  className='py-2 flex pl-4'>              <label className='ml-2 flex items-center gap-1 font-semibold'><LuSquareArrowOutUpRight /> Visit Website</label></div>
                                        <div onClick={() => setshowaddbutton(false)}                              className='py-2 flex pl-4 bg-[#f6f9fc]'><label className='ml-2 flex items-center gap-1 font-semibold'><FaWhatsapp /> Call on WhatsApp</label></div>
                                        <div onClick={() => { setshowaddbutton(false); setcallphone(true); }}     className='py-2 flex pl-4'>              <label className='ml-2 flex items-center gap-1 font-semibold'><IoCall /> Call Phone Number</label></div>
                                        <div onClick={() => setshowaddbutton(false)}                              className='py-2 flex pl-4 bg-[#f6f9fc]'><label className='ml-2 flex items-center gap-1 font-semibold'><FaClipboardCheck /> Complete Flow</label></div>
                                        <div onClick={() => { setshowaddbutton(false); setcopyoffercode(true); }} className='py-2 flex pl-4'>              <label className='ml-2 flex items-center gap-1 font-semibold'><FaCopy /> Copy Offer Code</label></div>
                                    </div>
                                )}
                            </button>

                            {custom && (
                                <div className='w-[100%] flex items-center justify-between mt-4 border-[#d4cfcf] border-[1px] p-3 rounded-md'>
                                    <div className='flex gap-2'>
                                        <div>
                                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff] mb-1 block'>Type</label>
                                            <select value={customvalueType} onChange={(e) => { setcustomvalueType(e.target.value); setcustomvalue(e.target.value === 'custom' ? 'Quick Reply' : 'Configured response'); }}
                                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none'>
                                                <option value="custom">Custom</option>
                                                <option value="Preconfigured">Pre-configured response</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff] mb-1 block'>Button text <span className='text-[10px] text-[#4d4b4b]'>{customvalue.length}/25</span></label>
                                            <input type="text" value={customvalue} onChange={(e) => setcustomvalue(e.target.value)} maxLength={25}
                                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none' />
                                        </div>
                                    </div>
                                    <RxCross1 onClick={() => setcustom(false)} className='cursor-pointer' />
                                </div>
                            )}
                            {visitwebsite && (
                                <div className='w-[100%] flex items-center justify-between mt-4 border-[#d4cfcf] border-[1px] p-3 rounded-md'>
                                    <div className='flex gap-2 w-[100%]'>
                                        <div><label className='text-[#000] text-[12px] font-semibold mb-1 block'>Button text</label><input type="text" value={visitwebsiteText} onChange={(e) => setvisitwebsitetext(e.target.value)} className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none' /></div>
                                        <div><label className='text-[#000] text-[12px] font-semibold mb-1 block'>URL type</label><select value={visitwebsiteURLtype} onChange={(e) => setvisitwebsiteURLtype(e.target.value)} className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none'><option value="Static">Static</option><option value="Dynamic">Dynamic</option></select></div>
                                        <div className='w-[50%]'><label className='text-[#000] text-[12px] font-semibold mb-1 block'>Website URL <span className='text-[10px]'>{visitwebsiteURL.length}/2000</span></label><input type="text" value={visitwebsiteURL} onChange={(e) => setvisitwebsiteURL(e.target.value)} maxLength={2000} className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none w-[80%]' /></div>
                                    </div>
                                    <RxCross1 onClick={() => setvisitwebsite(false)} className='cursor-pointer' />
                                </div>
                            )}
                            {callphone && (
                                <div className='w-[100%] flex items-center justify-between mt-4 border-[#d4cfcf] border-[1px] p-3 rounded-md'>
                                    <div className='flex gap-2 w-[100%]'>
                                        <div><label className='text-[#000] text-[12px] font-semibold mb-1 block'>Button text</label><input type="text" value={callphonebtntext} onChange={(e) => setcallphonebtntext(e.target.value)} className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none' /></div>
                                        <div><label className='text-[#000] text-[12px] font-semibold mb-1 block'>Country</label>
                                            <select value={countrycodetype} onChange={(e) => { setcountrycodetype(e.target.value); setcountrycode(e.target.value === 'IN+91' ? '+91' : e.target.value === 'UK+44' ? '+44' : '+1'); }} className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none'>
                                                <option value="IN+91">IN+91</option><option value="UK+44">UK+44</option><option value="US+1">US+1</option>
                                            </select>
                                        </div>
                                        <div className='w-[50%]'><label className='text-[#000] text-[12px] font-semibold mb-1 block'>Phone number</label>
                                            <div className='flex text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 w-[80%]'>{countrycode}<input type="text" value={phonenumber} onChange={(e) => setphonenumber(e.target.value)} maxLength={20} className='outline-none ml-2' /></div>
                                        </div>
                                    </div>
                                    <RxCross1 onClick={() => setcallphone(false)} className='cursor-pointer' />
                                </div>
                            )}
                            {copyoffercode && (
                                <div className='w-[100%] flex items-center justify-between mt-4 border-[#d4cfcf] border-[1px] p-3 rounded-md'>
                                    <div className='flex gap-2 w-[100%]'>
                                        <div><label className='text-[#000] text-[12px] font-semibold mb-1 block'>Button text</label><input type="text" value={copybtntext} readOnly className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none' /></div>
                                        <div className='w-[50%]'><label className='text-[#000] text-[12px] font-semibold mb-1 block'>Offer code</label>
                                            <div className='flex text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 w-[80%] justify-between'>
                                                <input type="text" value={offercode} onChange={(e) => setoffercode(e.target.value)} maxLength={15} className='outline-none ml-2' />
                                                <span>{offercode.length}/15</span>
                                            </div>
                                        </div>
                                    </div>
                                    <RxCross1 onClick={() => setcopyoffercode(false)} className='cursor-pointer' />
                                </div>
                            )}
                        </div>

                        {/* Validity period */}
                        <div className='w-[100%] mt-4 border-[#d4cfcf] border-[1px] p-3 rounded-md'>
                            <h6 className='text-[14px] text-[#000] font-semibold'>Message validity period</h6>
                            <p className='text-[11px] text-[#535252d7]'>Set a custom validity period. If not delivered within this time, you won't be charged.</p>
                            <div className='w-[100%] flex justify-between items-center mt-4 border-[#d4cfcf] border-[1px] p-2 rounded-md'>
                                <div>
                                    <h6 className='text-[14px] text-[#000] font-semibold'>Set custom validity period</h6>
                                    <p className='text-[11px] text-[#535252d7]'>Default is the standard 10 minutes WhatsApp validity period.</p>
                                </div>
                                <button onClick={() => setisActive(!isActive)}
                                    className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${isActive ? "bg-[#37715d]" : "bg-[#b4bbc3]"}`}>
                                    <div className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${isActive ? "translate-x-[13px]" : ""}`}></div>
                                </button>
                            </div>
                            {isActive && (
                                <div className='w-[100%] flex flex-col gap-1 mt-4'>
                                    <label className='text-[#000] flex gap-1 items-center text-[12px] font-semibold dark:text-[#fff]'>Validity period <BsInfoCircle /></label>
                                    <select value={Validity} onChange={(e) => setValidity(e.target.value)}
                                        className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 dark:bg-[#121519] dark:text-[#fff] w-[100%]'>
                                        <option value="43200">12 hours</option>
                                        <option value="86400">24 hours</option>
                                        <option value="172800">48 hours</option>
                                        <option value="259200">72 hours</option>
                                        <option value="345600">96 hours</option>
                                        <option value="604800">168 hours (7 days)</option>
                                    </select>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* ══════════ RIGHT PREVIEW PANEL ══════════ */}
                    <div className='w-[100%] md:w-[26%] sm:mt-[-40px] mt-[50px] p-4 flex flex-col justify-center relative md:fixed md:top-[100px] md:right-0'>
                        <div className='scale-[0.85] origin-top pb-3'>
                            <div className='w-[300px] bg-cover bg-center h-[600px] flex justify-center items-center'
                                style={{ backgroundImage: `url(${whatsappBgimage})` }}>
                                <div className='w-[266.5px] bg-cover bg-center bg-no-repeat bg-[#efeae2] h-[570px] rounded-[40px]'
                                    style={{ backgroundImage: `url(${whatsappBodyBgimage})` }}>
                                    <div className='bg-[#00816a] h-[75px] w-[100%] rounded-t-[20px] ml-[.5px] relative overflow-hidden'>
                                        <div className='w-[100%] flex justify-between px-2'>
                                            <div className='flex items-center gap-2 text-[12px] text-[#fff]'><span>12:00</span><FaWhatsapp /><FaInstagram /></div>
                                            <img src={whatsappnotch} alt="" className='w-[100px] h-[20px] object-content mt-[-10px]' />
                                            <div className='flex items-center gap-2 text-[12px] text-[#fff]'><FaWifi /><MdOutlineSignalCellularConnectedNoInternet4Bar /><MdBatteryFull /></div>
                                        </div>
                                        <div className='w-[100%] flex px-2 items-center justify-between py-1 gap-1'>
                                            <div className='flex items-center text-[#fff] gap-1'>
                                                <FaArrowLeftLong className='text-[28px]' />
                                                <img src={Whatsappicon} alt="" className='w-10 h-10' />
                                                <div className='flex flex-col'>
                                                    <span className='text-[12px] text-[#fff] font-bold'>
                                                        {whatsappData.find(d => d.waba_id === selectedWabaId)?.["Display Name"] ?? ''}
                                                    </span>
                                                    <span className='text-[10px] text-[#fff]'>Business Account</span>
                                                </div>
                                            </div>
                                            <div className='flex flex-col gap-1 text-[#fff]'><FaShop /><RxDotsVertical /></div>
                                        </div>
                                    </div>

                                    <div className='w-[100%] p-2 h-[500px] flex flex-col items-baseline justify-between'>
                                        <div className='bg-[#fff] w-[90%] p-1 rounded-lg pb-2'>
                                            <span className='text-[#1a1919] text-[13px] text-wrap break-words font-bold'>{previewText(headervalue, headerVars)}</span>
                                            <p style={{ whiteSpace: "pre-line" }} className='text-[#1a1919] text-[12px] font-semibold text-wrap break-words mt-1'>{bodyvalue}</p>
                                            <span className='text-[#1a1919] text-[12px] text-wrap break-words'>{footervalue}</span>
                                            {custom       && <div className='w-[100%] flex items-center justify-center'><button className='text-[12px] flex gap-1 items-center font-semibold text-[#1D9E91] mt-1'><BiSolidShare />{customvalue}</button></div>}
                                            {visitwebsite && <div className='w-[100%] flex items-center justify-center'><Link to={visitwebsiteURL}><button className='text-[12px] flex gap-1 items-center font-semibold text-[#1D9E91] mt-1'><BiSolidShare />{visitwebsiteText}</button></Link></div>}
                                            {callphone    && <div className='w-[100%] flex items-center justify-center'><button className='text-[12px] flex gap-1 items-center font-semibold text-[#1D9E91] mt-1'><IoCall />{callphonebtntext}</button></div>}
                                        </div>
                                        <div className='w-[100%] flex justify-between items-center gap-1'>
                                            <div className='bg-[#fff] flex justify-between px-2 py-3 rounded-lg w-[90%]'>
                                                <div className='flex items-center gap-2'><CiFaceSmile /><span className='text-[#575656] text-[12px]'>Enter your message</span></div>
                                                <div className='flex items-center gap-2 text-[#575656]'><FaPaperclip /><FaCamera /></div>
                                            </div>
                                            <div className='bg-[#448c71] h-[30px] w-[30px] rounded-full flex justify-center items-center text-[#fff]'><FaMicrophone /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Action buttons */}
                            <div className='flex w-[70%] justify-center mt-2 mb-2 gap-2'>
                                <button onClick={() => setopen(!open)}
                                    className='p-2 bg-[#d3dde6] rounded-md text-[14px] font-semibold'>
                                    Previous
                                </button>
                                <button
                                    onClick={submitTemplate}
                                    disabled={submitting}
                                    className={`p-2 rounded-md text-[14px] font-semibold text-[#fff] flex items-center gap-2 ${submitting ? 'bg-[#6eaaa0] cursor-not-allowed' : 'bg-[#00816a] hover:bg-[#006857]'}`}
                                >
                                    {submitting ? (
                                        <><span className='animate-spin inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full'></span> Submitting...</>
                                    ) : 'Submit for Review'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <Gobackmodal isOpen={open} onClose={() => setopen(false)} heading='Change will be lost if you go back'>
                    <div className='py-2 border-y-[1px] border-[#8b8a8a67] my-2'>
                        <p className='text-[10px] text-[#646262]'>You started editing this template but haven't submitted it yet. If you discard now, all your changes will be lost.</p>
                    </div>
                    <div className='w-[100%] flex justify-end gap-1'>
                        <button onClick={() => setopen(!open)} className='p-2 bg-[#d3dde6] rounded-md text-[12px] font-semibold text-[#555555]'>Continue</button>
                        <Link to='/WAMessage/WATemplate/SetupTemplate'>
                            <button className='p-2 bg-[#00816a] rounded-md text-[12px] font-semibold text-[#fff]'>Go Back</button>
                        </Link>
                    </div>
                </Gobackmodal>
            </div>
        </>
    );
}

export default Edittemplate;